<template>
  <div class="px-4 w-full">
    <div class="flex flex-col mb-4 gap-2 w-[400px]">
      <div>
        <h1 class="text-xl ">Artikel Nummern hinzufügen</h1>
      </div>
      <div class="flex">
        <span class="p-1 w-[120px]">ArtikelNummer:</span>
        <input v-model="artikelNummern" class="w-full border p-1 shadow" placeholder="1234, 5678, 91011">
      </div>
    </div>
    <div class="w-full flex gap-2 mb-2">
      <button class="bg-trader-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 mt-2" @click="deleteTrue">
        Hinzufügen
      </button>
      <button class="bg-trader-gray hover:bg-trader-blue hover:text-white w-1/2 rounded p-2 mt-2" @click="deleteFalse">
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/application/EventBus.js";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      artikelNummern: ''
    };
  },
  methods: {

    deleteTrue() {
      eventBus.closeModal();
      try {
        if (this.value.onAccept) {
          const nummernArray = this.artikelNummern.replaceAll(/\s+/g,',').split(',').map(num => num.trim());
          //remove empty strings
          nummernArray.forEach((num, index) => {
            if (num === '') {
              nummernArray.splice(index, 1);
            }
          });

          this.value.onAccept(nummernArray);
          eventBus.closeModal();
        }
      } catch (e) {
        console.error(e);
      }
    },
    deleteFalse() {
      eventBus.closeModal();
      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
  watch: {
   artikelNummern: function (val) {
     // this.addArtikelNummern();
    }
  }
};
</script>
